module.exports = __webpack_public_path__ + "static/media/material-link.5dc929c8.svg";